jQuery(function ($) {
    $(document).ready(function() {
        //open mobile menu 
        const menuIcon = $('[data-nav-menu-mobile-icon]');
        menuIcon.on('click', function() {

            let header = document.querySelector('.header');
            // get the position of the bottom of the header relative to scroll position of the top of the window
            let offset = header.getBoundingClientRect().top + header.offsetHeight;
            // calculate the height of the mobile menu and set it with inline css
            $('.header-nav-mobile').css('height', 'calc(100vh - ' + offset + 'px)');

            $(this).toggleClass('close');

            let slideTime = 250;

            if ($(this).hasClass('close')) {
                $('.header').toggleClass('stuck'); //set logo fixed
                $('.header-nav-mobile').slideDown(slideTime, function() {
                    // Animation complete.
                    $('body, html').css('overflow', 'hidden'); //dont allow scrolling the body if menu is open
                });
            } else {
                $('.header-nav-mobile').slideUp(slideTime, function() {
                    // Animation complete.
                    $('body, html').attr('style', ''); //allow scrolling the body again
                    $('.header').toggleClass('stuck'); //set logo fixed
                });
            }
        });

        //open submenu on mobile
        $('.nav-btn-item').on('click',function(e) {
            e.preventDefault();
            var $submenu = $(this).closest('li').find('.nav-level-2');
            $('.nav-level-2').not($submenu).slideUp();
            $submenu.slideToggle();
        });
    });
});


// WCAG desktopmenu
// Element selectors
const topButtons = document.querySelectorAll(".nav-main .nav-btn-item, .nav-main .nav-main-link-level-1");
const submenuLinks = document.querySelectorAll(".nav-main .nav-main-link-level-2");

// Event listeners voor top-level buttons en links
topButtons.forEach((element, index, elements) => {
    element.addEventListener("keydown", (event) => handleTopMenuKey(event, element, index, elements));
    if (element.tagName === "BUTTON") {
        element.addEventListener("click", () => toggleSubNav(element));
    }
});

// Event listeners voor submenu links
submenuLinks.forEach((link) => {
    link.addEventListener("keydown", (event) => handleSubmenuKey(event, link));
});

// key events voor top-level menu
function handleTopMenuKey(event, element, index, elements) {
    const key = event.key;

    switch (key) {
        case "ArrowRight":
            event.preventDefault();
            focusNext(elements, index);
            break;

        case "ArrowLeft":
            event.preventDefault();
            focusPrevious(elements, index);
            break;

        case "Enter":
        case " ":
            if (element.tagName === "BUTTON") {
                event.preventDefault();
                toggleSubNav(element);
            }
            break;

        case "ArrowDown":
            event.preventDefault();
            if (element.tagName === "BUTTON") {
                focusFirstSubmenuItem(element);
            }
            break;
    }
}

// Handle key events voor submenu links
function handleSubmenuKey(event, link) {
    const key = event.key;
    const parentMenu = link.closest("ul");

    switch (key) {
        case "ArrowDown":
            event.preventDefault();
            focusNextInMenu(link, parentMenu);
            break;

        case "ArrowUp":
            event.preventDefault();
            focusPreviousInMenu(link, parentMenu);
            break;

        case "Escape":
            event.preventDefault();
            closeSubMenu(link);
            break;
    }
}

// Navigation helpers
function focusNext(elements, currentIndex) {
    const nextIndex = (currentIndex + 1) % elements.length;
    elements[nextIndex].focus();
}

function focusPrevious(elements, currentIndex) {
    const prevIndex = (currentIndex - 1 + elements.length) % elements.length;
    elements[prevIndex].focus();
}

function focusFirstSubmenuItem(button) {
    const submenuId = button.getAttribute("aria-controls");
    const submenu = document.getElementById(submenuId);
    if (submenu && submenu.style.display === "block") {
        const firstItem = submenu.querySelector("a");
        if (firstItem) {
            firstItem.focus();
        }
    }
}

function focusNextInMenu(link, menu) {
    const nextItem = link.parentElement.nextElementSibling?.querySelector("a");
    if (nextItem) {
        nextItem.focus();
    }
}

function focusPreviousInMenu(link, menu) {
    const prevItem = link.parentElement.previousElementSibling?.querySelector("a");
    if (prevItem) {
        prevItem.focus();
    }
}

function focusParentButton(menu) {
    const controllingButton = document.querySelector(`button[aria-controls="${menu.id}"]`);
    if (controllingButton) {
        controllingButton.focus();
    }
}

// Menu toggle logica
function toggleSubNav(button) {
    const parentMenu = button.closest("li");
    const subMenuId = button.getAttribute("aria-controls");
    const subMenu = document.getElementById(subMenuId);
    const isExpanded = button.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
        // Sluit het submenu
        parentMenu.classList.remove("open-children");
        button.setAttribute("aria-expanded", "false");
        subMenu.setAttribute("aria-hidden", "true");
        subMenu.classList.remove("open");
    } else {
        // Sluit alle andere submenus
        closeAllSubmenus();

        // Open het geselecteerde submenu
        parentMenu.classList.add("open-children");
        button.setAttribute("aria-expanded", "true");
        subMenu.setAttribute("aria-hidden", "false");
        subMenu.classList.add("open");
    }

    // Focus op het eerste submenu-item
    const firstItem = subMenu.querySelector("a");
    if (firstItem) {
        firstItem.focus();
    }
}

function closeSubMenu(link) {
    const parentSubMenu = link.closest("ul");
    if (parentSubMenu) {
        parentSubMenu.classList.remove("open");
        focusParentButton(parentSubMenu);
    }
}

function closeAllSubmenus() {
    document.querySelectorAll(".nav-main .nav-main-item").forEach((menu) => {
        menu.classList.remove("open-children");
    });
    document.querySelectorAll(".nav-main .nav-level-2").forEach((menu) => {
        menu.classList.remove("open");
        menu.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll(".nav-main .nav-btn-item").forEach((button) => {
        button.setAttribute("aria-expanded", "false");
    });
}

// Sluit menu's bij klik buiten menu of Escape knop
document.addEventListener("click", (event) => {
    if (!event.target.closest(".nav-main")) {
        closeAllSubmenus();
    }
});

document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
        closeAllSubmenus();
    }
});